import { Fragment } from "react/jsx-runtime";
import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { kickoffDisplay, KickoffMessage } from "./KickoffMessage";
import { Message } from "./transcriptStyles";

export function resolveKickoff(entry: ChatEntryWithSubTables) {
  const kickoffKind = entry.userMessage?.actionKind;
  if (
    entry.entryType === "UserMessage" &&
    entry.userMessage &&
    kickoffKind &&
    kickoffKind in kickoffDisplay
  ) {
    return {
      text: entry.userMessage.text,
      ...kickoffDisplay[kickoffKind as keyof typeof kickoffDisplay],
    };
  }
  return null;
}

type Props = {
  kickoff: NonNullable<ReturnType<typeof resolveKickoff>>;
  dateMarker: React.ReactNode;
  hasPrev: boolean;
  hasNext: boolean;
};

export function KickoffRow({ kickoff, dateMarker, hasPrev, hasNext }: Props) {
  return (
    <Fragment>
      {dateMarker}
      <Message
        style={{
          marginTop: hasPrev ? 16 : 0,
          marginBottom: hasNext ? 16 : 0,
        }}
      >
        <KickoffMessage
          text={kickoff.text}
          icon={kickoff.icon}
          label={kickoff.label}
        />
      </Message>
    </Fragment>
  );
}
